import {
	  DirectionsBikeOutlined,
	  DirectionsBoatOutlined,
	  DirectionsBusOutlined,
	  DirectionsCarOutlined,
	  DirectionsSubwayOutlined,
	  DirectionsWalkOutlined,
	  FlightOutlined,
	  TrainOutlined
} from "@mui/icons-material";
import {Stack, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {red_900} from "../../reusables/js/APXTheme.js";


export interface Transport {
	  transportIcon: JSX.Element;
}


export interface TransportModes {
	  [name: string]: Transport;
}


export const transportModes: TransportModes = {
	  Flight: {transportIcon: <FlightOutlined/>},
	  Train: {transportIcon: <TrainOutlined/>},
	  Bus: {transportIcon: <DirectionsBusOutlined/>},
	  Car: {transportIcon: <DirectionsCarOutlined/>},
	  Subway: {transportIcon: <DirectionsSubwayOutlined/>},
	  Boat: {transportIcon: <DirectionsBoatOutlined/>},
	  Bike: {transportIcon: <DirectionsBikeOutlined/>},
	  Walk: {transportIcon: <DirectionsWalkOutlined/>}
};

export const defaultTransportName = Object.keys(transportModes)[1] /* TRAIN */;


interface TransportButtonGroupProps {
	  value: string;
	  onChange: (name: string)=>void;
}


export default function TransportButtonGroup({value, onChange}: TransportButtonGroupProps) {
	  const [transportName, setTransportName] = useState(value || defaultTransportName);
	  
	  useEffect(() => {
			 setTransportName(value);
	  }, [value]);
	  
	  const onToggleButtonGroupChange = (event, value) => {
			 setTransportName(value);
			 onChange(value);
	  };
	  return (
				 <>
						<Stack spacing={0.5}>
							  <ToggleButtonGroup onChange={onToggleButtonGroupChange} value={transportName} exclusive>
									 {
											Object.keys(transportModes).map((name, index) => (
													  <ToggleButton key={index} value={name} style={{backgroundColor: transportName === name ? red_900 : "inherit"}}>
															 {transportModes[name].transportIcon}
													  </ToggleButton>
											))
									 }
							  </ToggleButtonGroup>
							  <Typography variant={"caption"} align={"center"}> {transportName} </Typography>
						</Stack>
				 </>
	  );
}